'use memo';

import { AutopilotTaskDto } from '@urbanx/agx.activities.client';
import { AgxSelectChip, SelectChipOption } from '@urbanx/agx.ui-components2';
import { useCallback, useMemo } from 'react';

interface TaskAssigneeCellProps {
  task: AutopilotTaskDto;
  assigneeOptions: SelectChipOption[];
  onAssignTask: (assignee?: string, taskId?: string) => void;
}

const TaskAssigneeCell = ({ task, assigneeOptions, onAssignTask }: TaskAssigneeCellProps) => {
  const assigneeOptionsForTask = useMemo(() => {
    return assigneeOptions.map((option) => ({
      ...option,
      selected: option.value === task.assignedTo,
    }));
  }, [task.assignedTo, assigneeOptions]);

  const selectedAssigneeLabel = useMemo(() => {
    const selectedOption = assigneeOptions.find((option) => option.value === task.assignedTo);
    return selectedOption?.label === 'Unassigned' ? undefined : selectedOption?.label;
  }, [task.assignedTo, assigneeOptions]);

  const handleOnSelect = useCallback(
    (o: SelectChipOption[]) => {
      const selected = o.find((option) => option.selected)?.value;
      onAssignTask(selected, task.id);
    },
    [onAssignTask, task.id]
  );

  return (
    <AgxSelectChip
      id="assignedto"
      variant="icon"
      label=""
      onSelect={handleOnSelect}
      size="medium"
      type="single-select"
      defaultSelection={task.assignedTo}
      options={assigneeOptionsForTask}
      searchPlaceHolder="Search"
      align="right"
      hideFooter
      tooltip={selectedAssigneeLabel ?? 'Add user'}
    />
  );
};

export default TaskAssigneeCell;
